
import imageDealExternalAquisition from '@/modules/shared/assets/deal_types_external_acquisition.png'
import imageDealInternalAquisition from '@/modules/shared/assets/deal_types_internal_acquisition.png'
import imageDealWorkingCapital from '@/modules/shared/assets/deal_types_working_capital.png'
import imageDealRefinance from '@/modules/shared/assets/deal_types_refinance.png'
import imageDealBuilding from '@/modules/shared/assets/deal_types_commercial_building_and_renovation.png'
import imageDealRecruiting from '@/modules/shared/assets/deal_types_recruiting.png'

// STEP 1
export const dealTypes = [
  {
    title: 'External Acquisition (buy out)',
    name: 'External Acquisition (buy out)',
    icon: imageDealExternalAquisition,
  },
  {
    title: 'Internal Acquisition (buy in)',
    name: 'Internal Acquisition (buy in)',
    icon: imageDealInternalAquisition,
  },
  {
    title: 'Recruiting',
    name: 'Recruiting',
    icon: imageDealRecruiting,
  },
  {
    title: 'Refinance',
    name: 'Refinance',
    icon: imageDealRefinance,
  },
  {
    title: 'Working Capital',
    name: 'Working Capital',
    icon: imageDealWorkingCapital,
  },
  {
    title: 'Commercial Building & Renovation',
    name: 'Commercial Building & Renovation',
    icon: imageDealBuilding,
  },
]

// STEP 2
export const practiceTypes = [
  {
    name: 'Registered Representative',
    title: 'Registered Representative',
  },
  {
    name: 'RIA/Investment Advisor Representative',
    title: 'RIA/Investment Advisor Representative',
  },
  {
    name: 'OSJ Practice',
    title: 'OSJ Practice',
  },
  {
    name: 'CPA/Tax Practice',
    title: 'CPA/Tax Practice',
  },
  {
    name: 'Captive Insurance Agent',
    title: 'Captive Insurance Agent',
  },
  {
    name: 'Insurance Practice',
    title: 'General Agency / Agent',
  },
]

// STEP 4
export const loanTypes = [
  {
    title: 'SBA Loan',
    name: 'SBA',
    question: 'SBA Loan Features:',
    answers: [
      'Fixed or variable rates',
      'Often can finance 100%+ of a deal (i.e., no down payment required)',
      'SBA guaranty allows lender to be more competitive',
    ],
  },
  {
    title: 'Conventional Loan',
    name: 'Conv',
    question: 'Conventional Loan Features:',
    answers: [
      'Fixed rate loans',
      'Typically shorter term than SBA loans',
      'Lower closing/origination fees',
      'Faster close/less paperwork',
    ],
  },
  {
    title: 'No Preference',
    name: null,
    question: 'Still not sure?',
    answers: [
      'For the most options, look at both SBA and Conventional lenders.',
    ],
  },
]

export const loanRepaymentTypes = [
  {
    title: '7 Year Payback / 10 Year Amortization',
    name: '7 year payback',
    buttonColor: '#0096a6',
    description: 'This is the most common conventional loan structure and often provides the most competitive interest rate.',
  },
  {
    title: '10 Year Payback / 10 Year Amortization',
    name: 'Full 10 year payback',
    buttonColor: '#0096a6',
    description: 'This is the typical SBA loan term, but some of our conventional lenders offer 10 year financing as well, offering the most flexible repayment term.',
  },
  {
    title: 'Undecided/No Preference',
    name: null,
    buttonColor: '#0096a6',
  },
]

// STEP 6
export const creditScores = [
  {
    title: 'Excellent',
    name: 'Excellent',
    range: 'Greater Than 720',
  },
  {
    title: 'Good',
    name: 'Good',
    range: 'Between 680-719',
  },
  {
    title: 'Fair',
    name: 'Fair',
    range: 'Between 640-679',
  },
  {
    title: 'Poor',
    name: 'Poor',
    range: 'Less than 639',
  },
]

// STEP 7
export const lenderFeatures = [
  {
    title: 'Lend with significant client concentration',
    name: 'Lend with significant client concentration',
    tooltip: 'Lenders that do not have an issue with a small group of clients representing a significant amount of the total revenue.',
  },
  {
    title: 'Finance broker fee',
    name: 'Finance broker fee',
    tooltip: "Lenders that are willing to finance transaction costs such as 3rd party broker's fees; some lenders will not, resulting in the buyer having to pay such costs out of pocket.",
  },
  {
    title: 'Fixed interest rate',
    name: 'Fixed interest rate',
    tooltip: 'Fixed interest rates will not change over the life of the loan, but may be slightly higher than lenders offering a variable rate. Lenders offering variable rates may have the rate adjust monthly, quarterly, or sometimes on one rate resent after a few years.',
  },
  {
    title: 'Flexible Valuation Requirements',
    name: 'Valuation optional',
    tooltip: "Lenders that either don't require a valuation, or will use combined value of buyer and seller",
  },
  {
    title: 'No lender specific bank account required for deposit',
    name: 'No lender specific bank account required for deposit',
    tooltip: 'Some lenders require you to open a deposit account with them, where all revenue must be deposited.',
  },
  {
    title: 'Finance transactional books of business',
    name: 'Finance transactional books of business',
    tooltip: 'Lenders that will finance deals with sellers that have more than 40% of their revenue coming from one-time commissions.',
  },
  {
    title: 'Earn-outs allowed',
    name: 'Earn-outs allowed',
    tooltip: 'Select if you plan to pay the seller a % of revenue over a period of time. SBA lenders for example will not allow this.',
  },
  {
    title: 'Seller is permitted to remain involved past 12 months',
    name: 'Seller is permitted to remain involved past 12 months',
    tooltip: "SBA lenders for example will limit the seller's contractual involvement post-sale to 12-months and in a non-controlling role.",
  },
  {
    title: 'No lien on property',
    name: 'No lien on property',
    tooltip: 'Most lenders will want as much collateral as possible, but some focus on the business, while others want additional collateral in property.',
  },
  {
    title: 'No cash required to close',
    name: 'No cash required to close',
    tooltip: 'Lenders that will consistently provide up to 100% financing and/or roll closing costs into the loan, and do not require a buyer to bring cash to close the deal.',
  },
]

// STEP 9
export const deadlineSpeeds = [
  {
    title: 'Less than 30 days',
    name: 'Less than 30 days',
  },
  {
    title: 'Within 45 days',
    name: 'Within 45 days',
  },
  {
    title: 'Within 60 days',
    name: 'Within 60 days',
  },
]
